import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    TaskID: yup.string().required('Обязательное поле'),
    Text: yup.string().required('Обязательное поле')
});
